import React from 'react'
// import { Link } from 'react-router-dom';


export default function latestevent() {

    return (
        <>
            <div className="overflow-hidden">
                <img src="/assets/shapeline.png" alt="shape-line-top" className="block h-auto w-full rotate-180 opacity-90" />
            </div>

            <div className='py-20 bg-[#FFF5F3] relative'>
                <div>
                    <img
                        src="/assets/left-line.svg"
                        className="absolute left-0 top-2"
                        alt="leftline"
                    />
                </div>
                <div className='relative z-10 max-w-7xl mx-auto'>
                    <div className='flex items-center justify-center gap-7 mb-8' style={{ fontFamily: 'Philosopher, sans-serif' }}>
                        <h2 className='text-6xl'>Latest <span className='text-primary mb-9'>Events</span> & <span className='text-primary mb-9'>Activities</span></h2>
                    </div>
                    <div className='grid grid-cols-3 gap-8'>
                        <div>
                            <div className='p-3 rounded-3xl overflow-hidden inline-block'>
                                <div className="relative">
                                    <img src='./assets/abhishek.webp' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden max-w-full' />
                                    <div className="absolute top-2 left-2 bg-black/60 text-white text-sm px-2 py-1 rounded-xl flex flex-col items-center leading-tight">
                                        <span className="text-xl font-bold">15</span>
                                        <span className="text-xs uppercase">Mar</span>
                                        <span className="text-base">2025</span>
                                    </div>
                                </div>
                                <div className='text-2xl mb-3'>Divy Abhishek on Shri Harijayanti Utsav</div>
                                <div className='text-1xl text-gray-600'>Lörem ipsum plarade derad. Plaheten hemid då bende. Kar kristofobi nesade. Polyck kall. Euvasade väning och pär.Kar kristofobi nesade. Polyck kall.</div>
                            </div>
                        </div>
                        <div>
                            <div className='p-3 rounded-3xl overflow-hidden inline-block'>
                                <div className="relative">
                                    <img src='./assets/annkut.webp' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden max-w-full' />
                                    <div className="absolute top-2 left-2 bg-black/60 text-white text-sm px-2 py-1 rounded-xl flex flex-col items-center leading-tight">
                                        <span className="text-xl font-bold">15</span>
                                        <span className="text-xs uppercase">Mar</span>
                                        <span className="text-base">2025</span>
                                    </div>
                                </div>
                                <div className='text-2xl mb-3'>Divy Annkut on Harijayanti Utsav</div>
                                <div className='text-1xl text-gray-600'>Lörem ipsum plarade derad. Plaheten hemid då bende. Kar kristofobi nesade. Polyck kall. Euvasade väning och pär.Kar kristofobi nesade. Polyck kall.</div>
                            </div>
                        </div>
                        <div>
                            <div className='p-3 rounded-3xl overflow-hidden inline-block'>
                                <div className="relative">
                                    <img src='./assets/harijayanti.webp' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden max-w-full' />
                                    <div className="absolute top-2 left-2 bg-black/60 text-white text-sm px-2 py-1 rounded-xl flex flex-col items-center leading-tight">
                                        <span className="text-xl font-bold">15</span>
                                        <span className="text-xs uppercase">Mar</span>
                                        <span className="text-base">2025</span>
                                    </div>
                                </div>
                                <div className='text-2xl mb-3'>Celebrate Harijayanti Utsav</div>
                                <div className='text-1xl text-gray-600'>Lörem ipsum plarade derad. Plaheten hemid då bende. Kar kristofobi nesade. Polyck kall. Euvasade väning och pär.Kar kristofobi nesade. Polyck kall.</div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center mt-10">
                        <button className="bg-primary hover:bg-red-900 transition-all text-white px-8 py-3 rounded-full text-lg font-semibold shadow">
                            View More
                        </button>
                    </div>
                </div>
                <img
                    src="/assets/left-line.svg"
                    className="absolute right-0 bottom-2"
                    style={{ transform: 'scaleX(-1) scaleY(-1)' }}
                    alt="leftline"
                />
            </div>

            <div className="overflow-hidden">
                <img src="/assets/shapeline.png" alt="shape-line-bottom" className="block h-auto w-full opacity-90" />
            </div>
        </>
    )
}

